import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

type Props = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function RToLIcon(props: Props) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="RToLIcon"
      style={style}
    >
      <path d="M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4m-2 7v-3l-4 4 4 4v-3h12v-2z" />
    </svg>
  )
}
